export const desktopDefaultFontSize = 14;
export const mobileDefaultFontSize = 14;
export const fallbackFonts =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";

export const cssClassPrefix = 'cs';
